/**
 * Orphan User Message Detection
 *
 * Detects when the last message in a conversation is from the user
 * with no assistant reply, indicating a failed or incomplete generation.
 */

export interface Message {
  id: string
  role: "user" | "assistant"
  content: string
  created_at: string
}

export interface OrphanUserMessage {
  messageId: string
  content: string
  createdAt: string
}

/**
 * Finds an orphan user message (last message is user with no assistant reply)
 */
export function findOrphanUserMessage(messages: Message[]): OrphanUserMessage | null {
  if (!messages || messages.length === 0) {
    console.log("[v0][orphan] No messages found")
    return null
  }

  const lastMessage = messages[messages.length - 1]

  if (lastMessage.role !== "user") {
    console.log("[v0][orphan] Last message is not from user, no orphan detected")
    return null
  }

  console.log("[v0][orphan] Orphan user message detected:", {
    messageId: lastMessage.id.slice(-8),
    contentPreview: lastMessage.content.slice(0, 50),
  })

  return {
    messageId: lastMessage.id,
    content: lastMessage.content,
    createdAt: lastMessage.created_at,
  }
}
